
export class ProjectMappingDto {
    Id?: number;
    costCenterId: number;
    empId:number;
    // empName:string;
    projectId: number;
    // projectName:string;
    attenEligibility: boolean;
    assignedDate?: Date;
    unassignedDate?: Date;
    isActive?: boolean;
    createdAt? : Date | any;
    createdUser? : number;
    updatedAt? : Date | any;
    updatedUser? : number;
    versionFlag? : number;
    status?: boolean;
}

export const ProjectMappingDtoDefault : ProjectMappingDto = {
    Id: 1,
    costCenterId: 1,
    empId:1,
    // empName:"",
    projectId: 1,
    // projectName: "",
    attenEligibility: true,
    assignedDate: new Date,
    unassignedDate: new Date,
    isActive: true,
    createdAt: new Date,
    createdUser: 0,
    updatedAt: new Date,
    updatedUser: 0,
    versionFlag: 0,
    status: true,

};

